module.exports = require("@ember/-internals/glimmer");